import { TEXT } from '../../constants/errorTemplateConstants';
import ErrorTemplate from "../errorTemplate/ErrorTemplate";
import { useNavigate } from "react-router-dom";
import {
  CriticalHeadingContainer,
  CriticalNumber,
  CriticalText
} from "./styles";
import { ROUTES } from "../../constants/routesConstants";
import { DASHBOARD_EVENT_CARD_TEXT } from "../../../pages/Dashboard/dashboardConstants";

const DashboardEventCard = ({
  criticalEventsCount,
  loading,
  eventError,
  hasFetchedCriticalEventsOnce,
  refreshHandler
}) => {

  const navigate = useNavigate();

  const handleCriticalCountClick = () => {
    navigate(ROUTES.EVENTS, { state: { fromCriticalCount: true } });
  };

  if (eventError && !loading && !hasFetchedCriticalEventsOnce) {
    return <ErrorTemplate 
      title={TEXT.EVENTS_ERROR}
      description={TEXT.EVENTS_ERROR_DESC}
      onRefresh={refreshHandler}
      testId="dashboard-events-error"
    />;
  }

  if(loading) {
    return (
      <CriticalHeadingContainer>
        <CriticalText>{DASHBOARD_EVENT_CARD_TEXT.LOADING}</CriticalText>
      </CriticalHeadingContainer>
    );
  }

  return (
     <CriticalHeadingContainer>
      {criticalEventsCount ? (
        <>
         <CriticalNumber onClick={handleCriticalCountClick}>
            {criticalEventsCount}
          </CriticalNumber>
          <CriticalText>{DASHBOARD_EVENT_CARD_TEXT.CRITICAL_EVENTS_DETECTED}</CriticalText>
        </>
      ) : (
        <CriticalText>{DASHBOARD_EVENT_CARD_TEXT.NO_CRITICAL_EVENTS}</CriticalText>
      )}
    </CriticalHeadingContainer>
  );
};

export default DashboardEventCard;
